import { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { genResource } from 'utilities/api';
import {
  CROPWISE_PROXY_URL,
  CROPWISE_PROXY_V2_URL
} from 'utilities/apiConstants';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import { useStore } from 'components/Store';

const V2_RESOURCE_NAMES: Record<string, string> = {
  cropseason: 'cropseasons'
};

const useCropSeasonServiceApi = (
  resourceName: string,
  globalFlagKey: string,
  byOrgFlagKey: string
) => {
  const [apiV1] = useState(() =>
    genResource(resourceName, `${CROPWISE_PROXY_URL}/v2/base`)
  );
  const v2ResourceName = V2_RESOURCE_NAMES[resourceName] || resourceName;
  const [apiV2] = useState(() =>
    genResource(v2ResourceName, CROPWISE_PROXY_V2_URL)
  );
  const {
    state: { organization }
  } = useStore();
  const flags = useFlags();

  return featureFlagRenderItem(
    flags[globalFlagKey],
    flags[byOrgFlagKey],
    organization?.id
  )
    ? apiV2
    : apiV1;
};

export default useCropSeasonServiceApi;
